import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { affiliatesAPI } from '../../lib/api';
import { t } from '../../lib/i18n';
import { EmptyState, inputCls, panelCls, StatusBadge } from '../../components/ui';
import { nyTime } from '../../lib/nyTime';

const STATES = ['signup', 'activated', 'paid'];

export default function ReferralsPage() {
  const [data, setData] = useState(null);
  const [state, setState] = useState('');
  const [fraud, setFraud] = useState('');

  const load = useCallback(() => {
    affiliatesAPI.referrals({ state, fraud })
      .then(({ data }) => setData(data))
      .catch(() => toast.error(t('Could not load referrals')));
  }, [state, fraud]);
  useEffect(load, [load]);

  return (
    <div>
      <h1 className="mb-4 text-lg font-semibold">{t('Referrals')}</h1>
      <div className="mb-3 flex gap-2">
        <select className={`${inputCls} !w-40`} value={state} onChange={(e) => setState(e.target.value)}>
          <option value="">{t('All states')}</option>
          {STATES.map((s) => <option key={s} value={s}>{t(s)}</option>)}
        </select>
        <select className={`${inputCls} !w-40`} value={fraud} onChange={(e) => setFraud(e.target.value)}>
          <option value="">{t('Fraud: all')}</option>
          <option value="yes">{t('Fraud: flagged only')}</option>
        </select>
      </div>
      {data === null ? (
        <p className="text-sm text-mms-muted">{t('Loading…')}</p>
      ) : data.items.length === 0 ? (
        <EmptyState>{t('No referrals yet.')}</EmptyState>
      ) : (
        <div className={`${panelCls} overflow-x-auto`}>
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-mms-border text-left text-xs text-mms-faint">
                <th className="px-4 py-2.5 font-medium">{t('When')}</th>
                <th className="px-4 py-2.5 font-medium">{t('Referred member')}</th>
                <th className="px-4 py-2.5 font-medium">{t('Affiliate')}</th>
                <th className="px-4 py-2.5 font-medium">{t('State')}</th>
                <th className="px-4 py-2.5 font-medium text-right">{t('Revenue')}</th>
                <th className="px-4 py-2.5 font-medium">{t('Fraud')}</th>
                <th className="px-4 py-2.5" />
              </tr>
            </thead>
            <tbody>
              {data.items.map((r) => (
                <tr key={r.id} className="border-b border-mms-border/60 last:border-0">
                  <td className="px-4 py-2.5 whitespace-nowrap text-xs text-mms-muted">
                    {nyTime(r.created_at)}
                  </td>
                  <td className="px-4 py-2.5">
                    {r.referred?.name || '—'}
                    {r.referred_number ? <span className="ml-1 text-xs text-mms-faint">#{r.referred_number}</span> : null}
                  </td>
                  <td className="px-4 py-2.5">
                    {r.affiliate?.name || '—'} <code className="ml-1 text-xs text-mms-faint">{r.affiliate_code}</code>
                  </td>
                  <td className="px-4 py-2.5"><StatusBadge status={r.state} /></td>
                  <td className="px-4 py-2.5 text-right mms-num">{r.revenue}</td>
                  <td className="px-4 py-2.5">
                    {r.fraud ? <span className="text-xs text-[var(--mms-danger)]">{t('flagged')}</span> : '—'}
                  </td>
                  <td className="px-4 py-2.5 text-right">
                    <button
                      onClick={() =>
                        affiliatesAPI.referralAction(r.id, r.fraud ? 'release' : 'hold')
                          .then(load)
                          .catch((err) => toast.error(err.response?.data?.detail || t('Action failed')))
                      }
                      className="rounded-md border border-mms-border px-2.5 py-1 text-xs text-mms-muted hover:text-mms-text hover:border-[var(--mms-hover-border)]"
                    >
                      {r.fraud ? t('release') : t('hold')}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
